export default __webpack_public_path__ + "static/media/HUMID.b78dc5ca.webp";